import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { AddCircle, Info, Visibility } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import TableComponent from "../../../../../TableComponent/TableComponent";
// Assuming the API service will be created in this file
import { getCornelDepression } from "../../../../../../api/services/assessment";
import { formatDateField } from "../../../../../../base/FormatTime";
import { QK } from "../../../../../../base/qk";
import CreateCornellDepressionScaleModal from "./CreateCornellDepressionScaleModal";
import CornellDepressionScaleDetailsModal from "./CornellDepressionScaleDetailsModal";
import AssessmentRiskTooltip from "../AssessmentRiskTooltip";
import { cornellDepressionLevels } from "./cornellDepressionScale.config";

const CornellDepressionScale = () => {
  const { id: clientID } = useParams();
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const { data: cornellDepressionScales, isLoading } = useQuery(
    [QK.cornelDepressions, clientID],
    () => getCornelDepression(clientID),
    { enabled: !!clientID }
  );

  const handleShowDetailsModal = (assessment) => {
    setSelectedAssessment(assessment);
    setShowDetailsModal(true);
  };

  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    { field: "client_name", headerName: "Service User" },
    { field: "created_by_name", headerName: "Created By" },
    { field: "care_plan_name", headerName: "Care Plan" },
    { field: "score", headerName: "Score" },
    { field: "comments", headerName: "Comments" },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (assessment) => handleShowDetailsModal(assessment),
    },
  ];

  return (
    <div className="w-75 mx-auto">
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "white", color: "black", p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="h5">
                Cornell Depression Scale Assessment
              </Typography>
              <AssessmentRiskTooltip
                assessmentType="Cornell Depression Scale"
                riskLevels={cornellDepressionLevels}
                icon={Info}
                iconColor="info"
                size="small"
                placement="right"
              />
            </Box>
            <Button
              variant="contained"
              startIcon={<AddCircle />}
              color="primary"
              onClick={() => setShowCreateModal(true)}
            >
              New Assessment
            </Button>
          </Stack>
        </Box>
      </Card>
      <div>
        <TableComponent
          data={cornellDepressionScales || []}
          columns={columns}
          actions={actions}
          isLoading={isLoading}
          size="small"
        />
      </div>

      <CreateCornellDepressionScaleModal
        open={showCreateModal}
        handleClose={() => setShowCreateModal(false)}
      />
      <CornellDepressionScaleDetailsModal
        open={showDetailsModal}
        handleClose={() => setShowDetailsModal(false)}
        assessment={selectedAssessment}
      />
    </div>
  );
};

export default CornellDepressionScale;
